import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Language-specific SEO metadata
const seoData = {
  en: {
    title: "Xiamen Tower Technology - Import & Export Solutions from China",
    description: "Professional product sourcing, manufacturing support, and supply chain management from China. Multilingual team serving Europe, Americas, and worldwide.",
    keywords: "China sourcing, import export, product sourcing China, manufacturing China, supply chain, Xiamen, B2B sourcing",
    ogTitle: "Xiamen Tower Technology Co., Ltd. - Your Trusted Partner in China",
    ogDescription: "Connect with reliable Chinese manufacturers. Quality control, logistics support, and seamless international trade solutions."
  },
  de: {
    title: "Xiamen Tower Technology - Import & Export Lösungen aus China",
    description: "Professionelle Produktbeschaffung, Fertigungsunterstützung und Supply-Chain-Management aus China. Mehrsprachiges Team für Europa und weltweit.",
    keywords: "China Beschaffung, Import Export, Produktbeschaffung China, Fertigung China, Lieferkette, Xiamen, B2B Beschaffung",
    ogTitle: "Xiamen Tower Technology Co., Ltd. - Ihr verlässlicher Partner in China",
    ogDescription: "Verbinden Sie sich mit zuverlässigen chinesischen Herstellern. Qualitätskontrolle, Logistikunterstützung und nahtlose internationale Handelslösungen."
  },
  es: {
    title: "Xiamen Tower Technology - Soluciones de Importación y Exportación desde China",
    description: "Abastecimiento profesional de productos, soporte de fabricación y gestión de la cadena de suministro desde China. Equipo multilingüe para Europa, América y todo el mundo.",
    keywords: "abastecimiento China, importación exportación, productos China, fabricación China, cadena suministro, Xiamen, B2B",
    ogTitle: "Xiamen Tower Technology Co., Ltd. - Su Socio de Confianza en China",
    ogDescription: "Conéctese con fabricantes chinos confiables. Control de calidad, soporte logístico y soluciones de comercio internacional."
  },
  sl: {
    title: "Xiamen Tower Technology - Uvozno-izvozne rešitve iz Kitajske",
    description: "Profesionalno pridobivanje izdelkov, proizvodna podpora in upravljanje dobavne verige iz Kitajske. Večjezična ekipa za Evropo in po svetu.",
    keywords: "nabava Kitajska, uvoz izvoz, izdelki Kitajska, proizvodnja Kitajska, dobavna veriga, Xiamen, B2B",
    ogTitle: "Xiamen Tower Technology Co., Ltd. - Vaš zaupanja vreden partner na Kitajskem",
    ogDescription: "Povežite se z zanesljivimi kitajskimi proizvajalci. Kontrola kakovosti, logistična podpora in celovite mednarodne trgovinske rešitve."
  },
  sr: {
    title: "Xiamen Tower Technology - Увозно-извозна решења из Кине",
    description: "Професионална набавка производа, подршка у производњи и управљање ланцем снабдевања из Кине. Вишејезични тим за Европу и широм света.",
    keywords: "набавка Кина, увоз извоз, производи Кина, производња Кина, ланац снабдевања, Xiamen, B2B",
    ogTitle: "Xiamen Tower Technology Co., Ltd. - Ваш поуздани партнер у Кини",
    ogDescription: "Повежите се са поузданим кинеским произвођачима. Контрола квалитета, логистичка подршка и комплетна међународна трговинска решења."
  }
};

const SEOManager = () => {
  const { lang } = useParams();
  const currentLang = lang || 'en';
  const seo = seoData[currentLang] || seoData.en;
  const baseUrl = 'https://www.towertech-xm.com';

  useEffect(() => {
    // Update document title
    document.title = seo.title;

    // Update or create meta tags
    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Standard meta tags
    updateMeta('description', seo.description);
    updateMeta('keywords', seo.keywords);

    // Open Graph meta tags
    updateMeta('og:title', seo.ogTitle, true);
    updateMeta('og:description', seo.ogDescription, true);
    updateMeta('og:type', 'website', true);
    updateMeta('og:url', `${baseUrl}/${currentLang}`, true);
    updateMeta('og:site_name', 'Xiamen Tower Technology Co., Ltd.', true);
    updateMeta('og:locale', currentLang === 'en' ? 'en_US' : 
               currentLang === 'de' ? 'de_DE' : 
               currentLang === 'es' ? 'es_ES' : 
               currentLang === 'sl' ? 'sl_SI' : 'sr_RS', true);

    // Twitter Card meta tags
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', seo.ogTitle);
    updateMeta('twitter:description', seo.ogDescription);

    // Update HTML lang attribute
    document.documentElement.lang = currentLang;

    // Update canonical URL dynamically
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = `${baseUrl}/${currentLang}`;
    }

    // Update hreflang links with current page context
    const languages = ['en', 'de', 'es', 'sl', 'sr'];
    languages.forEach(langCode => {
      let hreflang = document.querySelector(`link[hreflang="${langCode}"]`);
      if (hreflang) {
        hreflang.href = `${baseUrl}/${langCode}`;
      }
    });

  }, [currentLang, seo]);

  return null; // This component doesn't render anything
};

export default SEOManager;
